import React from "react";
import "../../styles/CardNuoto.css"
import {useNavigate} from "react-router-dom";

interface CardNuotoProps {
    image: string;
    title: string;
    indirizzo: string;
}

function CardNuoto({ image, title, indirizzo }: CardNuotoProps) {
    const navigate = useNavigate()
    return (
        <div style={{ position: "relative", margin: "5px", textAlign: "center", width: "17em"}} onClick={()=>navigate(`${indirizzo}`)}>
            <img
                src={image}
                className="img-thumbnail"
                alt="..."
                style={{ width: "100%", maxWidth: "300px", height: "300px", objectFit: "cover" }}
            />
            <div
                style={{
                    position: "absolute",
                    top: "85%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "#447aa0",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    width: "80%",
                    textAlign: "center",
                    cursor: "pointer",
                    backgroundColor: "#ffffff",
                    borderRadius: "1em"
                }}
            >
                {title}
            </div>
        </div>
    );
}

export default CardNuoto;
